import axios from "axios";
import { IStatisticsResult, IStatistics } from "../models/statistics";

export const getStatistics = async (startDate: string, endDate: string) => {
    const res = await axios.get("/api/statistics", {
        params: { startDate: startDate, endDate: endDate },
    });
    return res.data as IStatisticsResult;
};

export const getCurrentActiveCertificates = async () => {
    const res = await axios.get("/api/statistics/active");
    return res.data as IStatistics;
};

export const exportCertificateStatistics = async (startDate: string, endDate: string) => {
    const res = await axios.get("/api/statistics/download", {
        params: { startDate: startDate, endDate: endDate },
        responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
    const link = document.createElement("a");
    link.href = url;
    const d = new Date();
    const date = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
    const fileName = "NCDB_statistics_" + date + ".csv";
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};
